<template>
  <main>
    <div class="container">
      <div class="row py-3 py-sm-5">
        <div class="col-12">
          <h1 class="text-white text-center">
            Request a password reset
          </h1>
        </div>
      </div>
    </div>
    <div class="container-fluid bg-white py-5">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <p>Enter your account email below to have a password reset link sent to it.</p><p>
                  <notifications />
                </p><form
                  ref="form"
                  @submit.prevent="request"
                >
                  <div class="form-group row">
                    <label
                      for="email"
                      class="col-md-4 col-form-label text-md-right"
                    >E-Mail Address</label>
                    <div class="col-md-6">
                      <input
                        id="email"
                        v-model="email"
                        type="email"
                        class="form-control"
                        required
                      >
                    </div>
                  </div>
                  <div class="form-group row mb-0">
                    <div class="col-md-6 offset-md-4">
                      <button
                        type="submit"
                        class="btn btn-primary"
                      >
                        Send Password Reset Link
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Passwords from '../services/passwords.js';

export default {
  data () {
    return {
      email: null,
    }
  },
  methods: {
    request() {
      Passwords.request({email: this.email}).then(res => {
        this.$store.dispatch('notifications/setSuccess', 'An email with a password resent link has been sent to you.')
      }).catch(err => {
        this.$store.dispatch('notifications/setError', 'An error occurred.  Pleae try again.');
      })
    }
  }
}
</script>
